/**
 * Narrow to a plain object: rejects `null` and arrays, both of which pass
 * `typeof value === "object"`.
 */
export function isPlainObject(
  value: unknown,
): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}
